// export const BASE_URL = "https://devadminapi.hive-o.com/api/v1/"; //dev ip
export const BASE_URL = "https://adminapi.hive-o.com/api/v1/"; //production url new
export const SCIENER_URL = "https://api.sciener.com/v3/";
// export const BASE_URL = "http://localhost:8082/api/v1/";
